export default __webpack_public_path__ + "static/media/060_corner2.vp8.31da2235.webm";